import React from 'react';
import {withRouter, Link} from "react-router-dom";
import Api from './../../api/api';
import Loader from "react-loader-spinner";


class Sectors extends React.Component{


    state = {
        data: null,
        lang:"",
        langUrl: ''
    }

    whatPage = () => {
        const {pathname} = this.props.location;
        return pathname;
    }

    setLang = (whatPage) => {
        let lang = 'en';
        if (whatPage.match(/^\/ar/gm)) { 
            lang = 'ar';
            document.title ="القطاعات / الارجان / تطوير عقاري";

        }
        else{
            document.title ="Sectors / Alargan / Real Estate Development";
        }

        this.setState({lang: lang, langUrl:(lang==="en")? '' : '/ar'});
    }

    componentDidMount(){
        const whatPage = this.whatPage();
        this.setLang(whatPage);
        
        Api.getAllSectors().then((response)=>{
            this.setState({data: response.data.sectors})
        });
        
    }

    renderSectorLinks = (data, lang) =>{
        const {langUrl} =this.state;
        return(
            <>
                {data.map((sector,i)=>{
                    const link = "/expertise/sectors/" + sector.id;
                    return(
                        <div className="sector-details">
                            <Link className="sector-details-name" to={langUrl+link}>{sector["name_" + lang]}</Link>
                            <Link to={langUrl+link}>{(lang ==="ar" )? "←":'→'}</Link>
                        </div>
                    )
                })}
            </>
        );
    }
    
    render (){
        const {data, lang} = this.state;
        return (
            <div className="sectors-page">
                {(data)? 
                    this.renderSectorLinks(data, lang)
                :<Loader className="loader" type="TailSpin" color="#80008D" height={100} width={100} />}
            </div>
        );
    }
}

export default withRouter(props => <Sectors {...props}/>);